import React, { useState, useMemo, useCallback, useEffect } from 'react';
import Title from 'components/UI/Title';
import Slider from 'components/UI/Slider';
import { CustomDot, CustomPagination } from 'components/UI/Slider/utils';
import LazyImage from 'components/UI/LazyImage';

import * as styles from './SliderFooter.module.scss';

export default function SliderFooter({ title, items, handlePushEvent }) {
  const [current, setCurrent] = useState(0);

  const setCurrentKey = useCallback((prev, next) => {
    setCurrent(next);
  }, []);

  const pushEvent = useCallback(() => {
    handlePushEvent('slide_change');
  }, []);

  useEffect(() => {
    setCurrent(0);
  }, [items.length]);

  const settings = useMemo(
    () => ({
      customPaging: CustomDot.bind(null, items.length, current),
      appendDots: CustomPagination,
      dotsClass: 'slick-pagination',
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 961,
          settings: {
            arrows: false,
          },
        },
      ],
    }),
    [items.length, current],
  );

  return (
    <div className="defaultSlider">
      <div className={styles.titleWrapper}>
        <Title className={styles.title} tag="h4" color="white">
          {title}
        </Title>
        <div className={styles.counter}>
          <span>{current + 1}</span> / <span>{items?.length}</span>
        </div>
      </div>
      <div className={styles.cardsWrapper} key={items.length}>
        <Slider {...settings} beforeChange={setCurrentKey} afterChange={pushEvent}>
          {items.map((item, i) => (
            <div key={i} className={styles.card} onClick={() => handlePushEvent('click_on_card')}>
              <div className={styles.logoWrapper}>
                <LazyImage className={styles.logo} src={item.logo} alt="Logo" />
              </div>
              <div className={styles.infoWrapper}>
                <div className={styles.countryWrapper}>
                  <LazyImage className={styles.flag} src={item.flag} alt="Logo" />
                  <p className={styles.country}>{item.country}</p>
                </div>
                <p className={styles.cardTitle}>{item.title}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
